import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import profileImage from "assets/img/landingPage/mockup-profile-image.png";
import pointsIcon from "assets/img/icons/points-icon.svg";
import dollarIcon from "assets/img/icons/dollar-icon.svg";
import calendarIcon from "assets/img/icons/calendar-icon.svg";
import bulbIcon from "assets/img/icons/tip-bulb.svg";
import discoverIcon from "assets/img/icons/menu-discover-white.svg";
import rightUpArrowIcon from "assets/img/icons/icons8-right-up-arrow.svg";

const Contest = styled.div`
  position: absolute;
  top: 36px;
  left: 0;
  width: 100%;
  box-sizing: border-box;

  margin: 0;
  padding: 0 7px;

  display: flex;
  flex-direction: column;

  opacity: ${(props) => (props.display ? 100 : 0)};

  transition: 0.2s;
`;

const ContestBox = styled.div`
  width: 100%;
  padding: 15px 10px 15px;
  box-sizing: border-box;
  margin-top: 8px;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: 10px;

  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ContestBoxTop = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  gap: 45px;
`;

const ContestBoxTopLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  flex: 1;
`;

const ContestBoxTitle = styled.div`
  width: 100%;

  font-size: 13px;
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};

  display: flex;
  flex-direction: column;
`;

const ContestText = styled.div`
  line-height: 125%;
  font-size: 11px;
`;

const CollectInfoBox = styled.div`
  width: 100%;
  padding: 10px;
  margin-top: 0px;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: ${css.BOX_RADIUS_SECONDARY};

  display: flex;
  gap: 8px;
`;

const CollectInfoBoxIcon = styled.div`
  width: 15px;
  min-width: 15px;
  height: 15px;
`;

const CollectInfoBoxText = styled.div`
  font-size: 11px;
`;

const OngoingContest = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

const OngoingColumns = styled.div`
  display: flex;
  gap: 14px 8px;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const OngoingColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Data = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const DataTitle = styled.div`
  font-weight: 500;
  font-size: 11px;

  display: flex;
  align-items: center;
  gap: 6px;
`;

const DataRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const DataIconBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DataIcon = styled.div`
  width: 16px;
  min-width: 16px;
  height: 16px;

  display: flex;
`;

const DataText = styled.div`
  white-space: nowrap;
  font-size: 11px;
`;

const ColumnContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const RankHigherInfoBox = styled.div`
  width: 100%;
  padding: 14px;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: 10px;

  display: flex;
  flex-direction: column;
  gap: 10px;

  flex: 1;
`;

const CollectTip = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const CollectTipIcon = styled.div`
  width: 16px;
  min-width: 16px;
  height: 16px;
`;

const CollectTipText = styled.div`
  font-size: 11px;
  font-weight: 400;
`;

const RankHigherInfoRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const RankHigherInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RankHigherInfoIconBox = styled.div``;

const RankHigherInfoIcon = styled.div`
  width: 15px;
  min-width: 15px;
  height: 15px;
`;

const RankHigherInfoText = styled.div`
  font-size: 11px;
`;

const RankHigherInfoButtonWrap = styled.div``;

const RankingBox = styled.div`
  width: 100%;
  padding: 8px 10px;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: 10px;

  display: flex;
  gap: 8px;
`;

const RankingAvatarColumn = styled.div``;

const RankingAvatarIconBox = styled.div`
  margin-top: 23px;
`;

const RankingAvatarIcon = styled.div`
  width: 18px;
  min-width: 18px;
  height: 18px;
`;

const RankingPositionsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const RankingPositionsRow = styled.div`
  height: 18px;

  display: flex;
  align-items: center;
  gap: 5px;
`;

const RankingPositionsStripe = styled.div`
  width: 3px;
  height: 100%;

  background: ${(props) => props.color};
`;

const RankingPositionsText = styled.div`
  font-size: 11px;
  font-weight: 400;
  white-space: nowrap;
`;

const ButtonRoundIcon = styled.div`
  width: 12px;
  height: 12px;

  transition: 0.2s;

  background-image: ${`url(${rightUpArrowIcon})`};
  background-repeat: no-repeat;
  background-size: cover;
`;

const ButtonRoundCircle = styled.div`
  width: 20px;
  min-width: 20px;
  height: 20px;
  box-sizing: border-box;

  border-radius: 50%;
  background: ${css.BRAND_YELLOW};
  border: 0px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export default ({ display }) => {
  return (
    <Contest display={display}>
      <ContestBox>
        <ContestBoxTop>
          <ContestBoxTopLeft>
            <ContestBoxTitle>Win Cash With Scalelup Contest</ContestBoxTitle>
            <ContestText>
              Be an active user and grab a valuable cash prize.
            </ContestText>
            <CollectInfoBox>
              <CollectInfoBoxIcon>
                <img src={pointsIcon} style={{ width: "100%" }} />
              </CollectInfoBoxIcon>
              <CollectInfoBoxText>
                Collect one contest point for each coin you earn
              </CollectInfoBoxText>
            </CollectInfoBox>
          </ContestBoxTopLeft>
        </ContestBoxTop>
        <OngoingContest>
          <ContestBoxTitle>Ongoing Contest</ContestBoxTitle>
          <OngoingColumns>
            <OngoingColumn>
              <Data>
                <DataTitle>Prize Pool</DataTitle>
                <DataRow>
                  <DataIconBox>
                    <DataIcon>
                      <img src={dollarIcon} style={{ width: "100%" }} />
                    </DataIcon>
                  </DataIconBox>
                  <DataText>2500 USD</DataText>
                </DataRow>
              </Data>
              <Data>
                <DataTitle>Term</DataTitle>
                <DataRow>
                  <DataIconBox>
                    <DataIcon width="18px">
                      <img src={calendarIcon} style={{ width: "100%" }} />
                    </DataIcon>
                  </DataIconBox>
                  <DataText>Nov 4 - Nov 11</DataText>
                </DataRow>
              </Data>
              <Data>
                <DataTitle>Points</DataTitle>
                <DataRow>
                  <DataIconBox>
                    <DataIcon>
                      <img src={pointsIcon} style={{ width: "100%" }} />
                    </DataIcon>
                  </DataIconBox>
                  <DataText>674</DataText>
                </DataRow>
              </Data>
            </OngoingColumn>
            <OngoingColumn>
              <ColumnContentWrap>
                <DataTitle>Your Ranking</DataTitle>
                <RankingBox>
                  <RankingAvatarColumn>
                    <RankingAvatarIconBox>
                      <RankingAvatarIcon>
                        <img
                          src={profileImage}
                          style={{ width: "100%", borderRadius: "50%" }}
                        />
                      </RankingAvatarIcon>
                    </RankingAvatarIconBox>
                  </RankingAvatarColumn>
                  <RankingPositionsColumn>
                    <RankingPositionsRow>
                      <RankingPositionsStripe color={css.BRAND_YELLOW} />
                      <RankingPositionsText>1 - 10</RankingPositionsText>
                    </RankingPositionsRow>
                    <RankingPositionsRow>
                      <RankingPositionsStripe color={css.BRAND_GREEN} />
                      <RankingPositionsText>11 - 100</RankingPositionsText>
                    </RankingPositionsRow>
                    <RankingPositionsRow>
                      <RankingPositionsStripe color={css.BRAND_INDIGO} />
                      <RankingPositionsText>101 - 1000</RankingPositionsText>
                    </RankingPositionsRow>
                    <RankingPositionsRow>
                      <RankingPositionsStripe color={css.BRAND_BLUSH} />
                      <RankingPositionsText>1001+</RankingPositionsText>
                    </RankingPositionsRow>
                  </RankingPositionsColumn>
                </RankingBox>
              </ColumnContentWrap>
            </OngoingColumn>
            <OngoingColumn>
              <ColumnContentWrap>
                <DataTitle>How to Rank Higher</DataTitle>
                <RankHigherInfoBox>
                  <CollectTip>
                    <CollectTipIcon>
                      <img src={bulbIcon} style={{ width: "100%" }} />
                    </CollectTipIcon>
                    <CollectTipText>
                      Collect points by earning coins
                    </CollectTipText>
                  </CollectTip>
                  <RankHigherInfoRows>
                    <RankHigherInfoRow>
                      <RankHigherInfoIconBox>
                        <RankHigherInfoIcon>
                          <img src={discoverIcon} style={{ width: "100%" }} />
                        </RankHigherInfoIcon>
                      </RankHigherInfoIconBox>
                      <RankHigherInfoText>
                        Find coins by exploring opportunities
                      </RankHigherInfoText>
                      <RankHigherInfoButtonWrap>
                        <ButtonRoundCircle>
                          <ButtonRoundIcon />
                        </ButtonRoundCircle>
                      </RankHigherInfoButtonWrap>
                    </RankHigherInfoRow>
                  </RankHigherInfoRows>
                </RankHigherInfoBox>
              </ColumnContentWrap>
            </OngoingColumn>
          </OngoingColumns>
        </OngoingContest>
      </ContestBox>
    </Contest>
  );
};
